import { Attribute } from "../gql/graphql";
import { CardType } from "../types";

export const isCardPresent = (card: CardType | null, cards: ({ attribute: Attribute } | null)[]) =>
  Boolean(card && cards.map((c) => (c ? c.attribute : null)).includes(card.attribute));
